/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Servers_Status_Needs_AuthorizationInputs */



/**
* | output |
* | --- |
* | "Sign-in required" |
*
* @param {Mcp_Servers_Status_Needs_AuthorizationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mcp_servers_status_needs_authorization = /** @type {((inputs?: Mcp_Servers_Status_Needs_AuthorizationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Servers_Status_Needs_AuthorizationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anmeldung erforderlich")
	return /** @type {LocalizedString} */ ("Sign-in required")
});